import {qsa} from './querySelector';

export function getFormData(form) {
  return [...qsa(form)`input, select, textarea`]
    .filter((x) => x.name && x.offsetParent)
    .reduce((acc, x) => {
      if (x.tagName.toLowerCase() === 'input' && ['radio', 'checkbox'].includes(x.type)) {
        if (!x.checked) {
          return acc;
        }

        acc[x.name] = x.value;
        return acc;
      }

      acc[x.name] = x.value;
      return acc;
    }, {});
}

export function generateFormPayload(dataObject) {
  return dataObject !== null && typeof dataObject === 'object'
    ? Object.keys(dataObject)
      .map((key) => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(dataObject[key])}`;
      })
      .join('&')
    : '';
}
